<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/setup/team-mapping" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("setup.label.ViewTeamMapping") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteUserDataPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("setup.label.CityName") }}</b>
                </td>
                <td>{{ editMappingTemplate.cityName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Category") }}</b>
                </td>
                <td>{{ editMappingTemplate.category }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.SubCategory") }}</b>
                </td>
                <td>{{ subs }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.TeamId") }}</b>
                </td>
                <td>{{ editMappingTemplate.teamId }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.TeamHead") }}</b>
                </td>
                <td>{{ editMappingTemplate.username }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteUserDataPopup"
      :title="$t('setup.label.PriorityMapping')"
      @deletePressed="deleteUserData()"
      @cancelPressed="deleteUserDataPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      teamMapping: {},
      deleteUserDataPopup: false,
      subs: "",
    };
  },

  computed: {
    ...mapState({
      editMappingTemplate: (state) => state.teamMapping.editMappingTemplate,
      categoryTemplate: (state) => state.teamMapping.categoryTemplate,
    }),
  },
  methods: {
    async getTeamMappingList() {
      try {
        await this.$store.dispatch(
          "teamMapping/fetchEditTeamMappingTemplate",
          this.$route.params.id
        );
        await this.$store.dispatch(
          "teamMapping/fetchCategoryTemplate",
          this.editMappingTemplate.categoryId
        );
        this.subs = this.categoryTemplate
          .filter((el) =>
            this.editMappingTemplate.subcategories.includes(el.id)
          )
          .map((i) => i.subCategory)
          .join(", ");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },

    editData() {
      this.$router.push(
        `/setup/team-mapping/editTeamMapping/${this.$route.params.id}`
      );
    },
  },
  filters: {},
  created() {
    this.getTeamMappingList();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
